export default "__VITE_PUBLIC_ASSET__f6b14b06__"